module.exports = __webpack_public_path__ + "media/locales/_it-763e6a99.png";